import { gql } from '@apollo/client'
import { OrderAllFieldsNodeFragment, StatusChangeNodeFragment } from '@src/graphql/Order/Fragments'

const editOrderVariables = `
  $customer: ID!
  $driver: ID
  $note: String
  $noteDriver: String
  $order: ID!
  $planDate: DateTime
  $repeat: Boolean
  $isPlausible: Boolean
  $supplier: ID
  $transportMedia: ID
  $vehicle: ID
  $repeatEndDate: DateTime
  $deliveryNumber: String
  $weightFormNumber: String
`

const editOrderArgs = `
  order: $order
  customer: $customer
  driver: $driver
  note: $note
  noteDriver: $noteDriver
  planDate: $planDate
  repeat: $repeat
  isPlausible: $isPlausible
  supplier: $supplier
  transportMedia: $transportMedia
  vehicle: $vehicle
  repeatEndDate: $repeatEndDate
  deliveryNumber: $deliveryNumber
  weightFormNumber: $weightFormNumber
`

const setOrderStatusVariables = `
  $idList: [ID]!
  $status: StatusChoice!
  $dispatchedAt: DateTime
  $repeatOnFinished: Boolean
  $accuracy: Decimal
  $longitude: Decimal
  $latitude: Decimal
  $milage: Int
`

const setOrderStatusArgs = `
  idList: $idList
  status: $status
  dispatchedAt: $dispatchedAt
  repeatOnFinished: $repeatOnFinished
  accuracy: $accuracy
  longitude: $longitude
  latitude: $latitude
  milage: $milage
`

export const createOrder = gql`
  mutation createOrder(
    $customer: ID!
    $driver: ID
    $note: String
    $piles: [String]
    $routes: [String]
    $planDate: DateTime
    $repeat: Boolean
    $supplier: ID
    $vehicle: ID
    $transportMedia: ID
    $repeatEndDate: DateTime
  ) {
    createOrder(
      customer: $customer
      driver: $driver
      routes: $routes
      note: $note
      piles: $piles
      planDate: $planDate
      repeat: $repeat
      supplier: $supplier
      vehicle: $vehicle
      transportMedia: $transportMedia
      repeatEndDate: $repeatEndDate
    ) {
      ok
    }
  }
`

export const editOrder = gql`
  mutation editOrder(${editOrderVariables}) {
    editOrder( ${editOrderArgs} ) {
      ok
    }
  }
`

export const appendPilesToExistingOrder = gql`
  mutation appendPilesToExistingOrder($orderId: ID!, $pileIdList: [ID]!) {
    appendPilesToExistingOrder(orderId: $orderId, pileIdList: $pileIdList) {
      ok
    }
  }
`

export const deletePilesFromExistingOrder = gql`
  mutation deletePilesFromExistingOrder($orderId: ID!, $pileIdList: [ID]!) {
    deletePilesFromExistingOrder(orderId: $orderId, pileIdList: $pileIdList) {
      ok
    }
  }
`

export const setOrderStatus = gql`
  mutation setOrderStatus(${setOrderStatusVariables}) {
    setOrderStatus(${setOrderStatusArgs}) {
      ok
      orders {
        ...orderAllFieldsNode
      }
    }
  }
  ${OrderAllFieldsNodeFragment}
`

export const editOrderIsPlausible = gql`
  mutation editOrderIsPlausible($orderId: ID!, $isPlausible: Boolean!) {
    editOrderIsPlausible(orderId: $orderId, isPlausible: $isPlausible) {
      ok
      order {
        id
        isPlausible
      }
    }
  }
`

export const setOrderStatusAndUpdateOrder = gql`
  mutation setOrderStatusAndEditOrder(
        ${setOrderStatusVariables}
        $orderId: ID!
        $deliveryNumber: String
        $weightFormNumber: String
      ) {
    editOrderDeliveryWeightFormNumber( 
      orderId: $orderId
      deliveryNumber: $deliveryNumber
      weightFormNumber: $weightFormNumber
    ) {
      ok
    }
    
    setOrderStatus( ${setOrderStatusArgs} ) {
      ok
      orders {
        ...orderAllFieldsNode
      }
    }
  }
  ${OrderAllFieldsNodeFragment}
`

export const editOrderAndMilages = gql`
  mutation editOrderAndMilages(
    $loadedStatusChangeId: ID!
    $loadedMilage: Int!
    $finishedStatusChangeId: ID!
    $finishedMilage: Int!
    $doLoaded: Boolean!
    $doFinished: Boolean!
    ${editOrderVariables}
  ) {
    loadedUpdate: updateMilageOnStatusChange(statusChangeId: $loadedStatusChangeId, milage: $loadedMilage)
      @include(if: $doLoaded) {
      ok
      vehicleMilageChanged
    }
    finishedUpdate: updateMilageOnStatusChange(statusChangeId: $finishedStatusChangeId, milage: $finishedMilage)
      @include(if: $doFinished) {
      ok
      vehicleMilageChanged
    }
    editOrder( ${editOrderArgs} ) {
      ok
    }
  }
`

export const setDeliveryNoteCustomer = gql`
  mutation setDeliveryNoteCustomer($orderId: ID!, $deliveryNoteCustomerId: ID!) {
    setDeliveryNoteCustomer(orderId: $orderId, deliveryNoteCustomerId: $deliveryNoteCustomerId) {
      ok
    }
  }
`

export const setDeliveryNoteSupplier = gql`
  mutation setDeliveryNoteSupplier($orderId: ID!, $deliveryNoteSupplierId: ID!) {
    setDeliveryNoteSupplier(orderId: $orderId, deliveryNoteSupplierId: $deliveryNoteSupplierId) {
      ok
    }
  }
`

export const saveRoute = gql`
  mutation changeRoute($orderId: ID!, $routes: [RouteNodeInput]!) {
    changeRoute(orderId: $orderId, routes: $routes) {
      ok
    }
  }
`

export const rollbackOrderStatusChange = gql`
  mutation rollbackOrderStatusChange($orderId: ID!) {
    rollbackOrderStatusChange(orderId: $orderId) {
      order {
        statusChanges {
          ...statusChange
        }
      }
    }
  }
  ${StatusChangeNodeFragment}
`

export const changeToNextStatus = gql`
  mutation changeToNextStatus($orderId: ID!) {
    changeToNextStatus(orderId: $orderId) {
      ok
    }
  }
`
